/* ── Core Charge quantity sync ──────────────────────────────────────────────
   Reads the two data islands rendered by snippets/core-charge-cart-data.liquid
   (in cart-drawer.liquid and main-cart.liquid) and keeps each core-charge
   line's quantity matched to the combined quantity of whatever tagged
   products require that exact dollar amount — covers quantity changes on
   the main product, removing it entirely (the paired charge is removed
   too), and multiple different tagged products sharing or differing in
   their required amount. No-ops completely on stores that don't use Core
   Charge (both data islands render empty arrays).
   ───────────────────────────────────────────────────────────────────────── */
(() => {
  const readJSON = (selector) => {
    try {
      const el = document.querySelector(selector);
      return el ? JSON.parse(el.textContent) : [];
    } catch (_) {
      return [];
    }
  };

  const sync = () => {
    const requirements = readJSON('[data-core-charge-requirements]');
    const current = readJSON('[data-core-charge-current]');
    if (!requirements.length && !current.length) return;

    const requiredMap = new Map();
    requirements.forEach(({ variantId, quantity }) => {
      const key = String(variantId);
      requiredMap.set(key, (requiredMap.get(key) || 0) + quantity);
    });

    const currentMap = new Map();
    current.forEach(({ variantId, quantity }) => {
      currentMap.set(String(variantId), quantity);
    });

    const corrections = [];

    requiredMap.forEach((requiredQty, variantId) => {
      if ((currentMap.get(variantId) || 0) !== requiredQty) {
        corrections.push({ id: variantId, quantity: requiredQty });
      }
    });

    // Orphaned core-charge lines — the tagged product they belonged to was
    // removed entirely (or its quantity dropped to where no products need
    // this amount anymore), so nothing requires this charge now.
    currentMap.forEach((_qty, variantId) => {
      if (!requiredMap.has(variantId)) {
        corrections.push({ id: variantId, quantity: 0 });
      }
    });

    if (!corrections.length) return;

    const root = window.Shopify?.routes?.root || '/';

    Promise.all(
      corrections.map((c) =>
        fetch(`${root}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: c.id, quantity: c.quantity })
        })
      )
    )
      .then(() =>
        Promise.all([
          fetch(`${root}cart.js`).then((r) => r.json()),
          fetch(`${root}?sections=cart-drawer`).then((r) => r.json())
        ])
      )
      .then(([cartData, sectionsData]) => {
        if (window.theme?.renderCartResponse) {
          window.theme.renderCartResponse({
            sections: { 'cart-drawer': sectionsData['cart-drawer'] },
            item_count: cartData.item_count
          });
        }
      })
      .catch(() => {});
  };

  document.addEventListener('DOMContentLoaded', sync);
  window.LakiCoreCharge = { sync };
})();
